export enum MfaType {
	'SMS_MFA' = 'SMS_MFA',
	'SOFTWARE_TOKEN_MFA' = 'SOFTWARE_TOKEN_MFA',
}
